(() => {
  const HOME_HERO_SELECTOR =
    'html.ns-header-on-hero #MainContent > .shopify-section:first-child .banner__media img[srcset]';
  const MOBILE_CROP_SIZES = '(max-width: 749px) 1920px, 100vw';

  function applyHighResolutionSource(root = document) {
    const image = root.querySelector?.(HOME_HERO_SELECTOR) || document.querySelector(HOME_HERO_SELECTOR);

    if (!image || image.dataset.hyMobileHeroQuality === 'true') return false;

    image.dataset.hyMobileHeroQuality = 'true';
    image.setAttribute('sizes', MOBILE_CROP_SIZES);
    image.setAttribute('fetchpriority', 'high');

    return true;
  }

  if (!document.documentElement.classList.contains('ns-header-on-hero')) return;

  if (applyHighResolutionSource()) return;

  const observer = new MutationObserver(() => {
    if (applyHighResolutionSource()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('shopify:section:load', (event) => {
    applyHighResolutionSource(event.target);
  });
})();